// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let NumberUtils = require("../NumberUtils.bs.js");
let Stdlib_List = require("@rescript/runtime/lib/js/Stdlib_List.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyAttributes = require("../../cap/Property/components/PropertyAttributes.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let CondoPropertyAttributes_condoProperty_graphql = require("../../../__generated__/CondoPropertyAttributes_condoProperty_graphql.bs.js");

let convertFragment = CondoPropertyAttributes_condoProperty_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, CondoPropertyAttributes_condoProperty_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(CondoPropertyAttributes_condoProperty_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, CondoPropertyAttributes_condoProperty_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(CondoPropertyAttributes_condoProperty_graphql.node, convertFragment, fRef);
}

let PropertyTypeFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function CondoPropertyAttributes(props) {
  let __displayPropertyType = props.displayPropertyType;
  let displayPropertyType = __displayPropertyType !== undefined ? __displayPropertyType : true;
  let match = RescriptRelay_Fragment.useFragment(CondoPropertyAttributes_condoProperty_graphql.node, convertFragment, props.propertyType);
  let halfBaths = match.halfBaths;
  let beds = match.beds;
  let baths = match.baths;
  let attributes = Stdlib_List.filterMap({
    hd: [
      beds.toString(),
      beds === 1 ? "Bed" : "Beds"
    ],
    tl: {
      hd: [
        NumberUtils.formatFloat(baths),
        (baths | 0) === 1 ? "Bath" : "Baths"
      ],
      tl: {
        hd: [
          Stdlib_Option.map(halfBaths, v => v.toString()),
          Stdlib_Option.map(halfBaths, hb => {
            if (hb === 1) {
              return "HalfBath";
            } else {
              return "HalfBaths";
            }
          })
        ],
        tl: {
          hd: [
            Stdlib_Option.map(match.lotSize, v => v.toString()),
            "SqftLot"
          ],
          tl: {
            hd: [
              Stdlib_Option.map(match.livingArea, v => v.toString()),
              "Sqft"
            ],
            tl: {
              hd: [
                displayPropertyType ? match.displayName : undefined,
                "Empty"
              ],
              tl: /* [] */0
            }
          }
        }
      }
    }
  }, param => {
    let snd = param[1];
    let fst = param[0];
    if (fst !== undefined && snd !== undefined) {
      return [
        fst,
        snd
      ];
    }
  });
  return JsxRuntime.jsx(PropertyAttributes.make, {
    propertyAttributes: attributes,
    size: props.size
  });
}

let formatFloat = NumberUtils.formatFloat;

let make = CondoPropertyAttributes;

exports.PropertyTypeFragment = PropertyTypeFragment;
exports.formatFloat = formatFloat;
exports.make = make;
/* react/jsx-runtime Not a pure module */
